import { createFileRoute } from "@tanstack/react-router";

import ConnectSuggestions from "@/pages/connect/suggestions";

export const Route = createFileRoute("/connect/suggestions")({
  component: ConnectSuggestionsPage,
  head: () => ({ meta: [{ title: "Connect: People you may know" }] }),
});

function ConnectSuggestionsPage() {
  return <ConnectSuggestions />;
}
